import { PaymentProviderType } from "@redotech/redo-billing-common/billing-engine-types";
import { contextualPlanSchema } from "@redotech/redo-billing-common/contextual-billing-settings";
import * as z from "zod";

/**
 * Set a team's CTX billing plan from redo admin. `usage` is the default
 * volume-tiered plan; `overage` carries a per-team base fee, included session
 * allowance, and per-session overage rate. Forwards to the billing service's
 * `setCtxPlan` RPC (which owns validation + persistence).
 */
export const setCtxPlan = {
  name: "setCtxPlan" as const,
  input: z.object({
    teamId: z.string(),
    plan: contextualPlanSchema,
    /** First-bill date. Omit to keep the existing anchor. */
    startDate: z.date().optional(),
    /** Rail the team is charged on. Omit to leave unchanged. */
    paymentProvider: z.nativeEnum(PaymentProviderType).optional(),
  }),
  output: z.object({ planType: z.string() }),
};
